    <div class="modal-header">
        <h2 class="modal-title" translate>lblAlternatePart <em class="fas fa-long-arrow-alt-right"></em>{{selectedPart.partNumber ? selectedPart.partNumber : partService.searchPartNumber}}</h2>
        <button type="button" class="close" aria-label="Close" (click)="OnClose()">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body p-0 min-h500">
        <div class="card pad15 border">
            <div class="row">
                <div class="col">
                    <div class="af-form-group">
                        <label translate>lblMake</label>
                        <div class="lbl-info">{{selectedPart.makeCode}}</div>
                    </div>
                </div>
                <div class="col">
                    <div class="af-form-group">
                        <label translate>lblLocationName</label>
                        <div class="lbl-info">{{selectedPart.locationCode}} {{selectedPart.locationName}}</div>
                    </div>
                </div>
                <div class="col-2">
                    <div class="af-form-group">
                        <label translate>lblDescription</label>
                        <div class="lbl-info">{{selectedPart.description}}</div>
                    </div>
                </div>
                <div class="col text-right">
                    <div class="af-form-group">
                        <label translate>lblPrice</label>
                        <div class="lbl-info">{{selectedPart.unitPrice |number: '1.2-2'}}</div>
                    </div>
                </div>
                <div class="col text-right">
                    <div class="af-form-group">
                        <label translate>lblPriceInc</label>
                        <div class="lbl-info">{{selectedPart.unitPriceInclVat |number: '1.2-2'}}</div>
                    </div>
                </div>
                <div class="col text-right">
                    <div class="af-form-group">
                        <label translate>lblTotalQty</label>
                        <div class="lbl-info">{{selectedPart.quantity |number: '1.2-2'}}</div>
                    </div>
                </div>
                <div class="col text-right">
                    <div class="af-form-group">
                        <label translate>lblAvlQty</label>
                        <div class="lbl-info">{{selectedPart.availableQuantity |number: '1.2-2'}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pad15">
            <div class="table-responsive">
                <table class="tablest1">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 20px" class="pl-1" translate></th>
                            <th scope="col" style="width: 20px" class="pl-1" translate></th>
                            <th scope="col" translate>lblMake</th>
                            <th scope="col" translate>lblLocationName</th>
                            <th scope="col" translate>lblPartNumber</th>
                            <th scope="col" translate>lblDescription</th>
                            <th scope="col" class="text-right" translate>lblPrice</th>
                            <th scope="col" class="text-right" translate>lblPriceInc</th>
                            <th scope="col" class="text-right" translate>lblTotalQty</th>
                            <th scope="col" class="text-right" translate>lblAvlQty</th>
                            <th scope="col" style="width:100px" translate>lblQtyShort</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="alternativePartsList?.length>0; else load_NotFoundAlter_Template">
                            <ng-container *ngFor="let part of alternativePartsList; let i=index">
                                <tr [ngClass]="{'bg-info': part.expanded}">
                                    <td>
                                        <div class="form-check p-1">
                                            <input type="checkbox" [(ngModel)]="part.isPartSelected" [checked]="part.isPartSelected" />
                                        </div>
                                    </td>
                                    <td (click)="part.expanded = !part.expanded" class="pl-1">
                                        <a class="btn btn-ico" ngbTooltip="Check Availability" (click)="getPartLocation(part.partNumber,i)" tooltipClass="custom-revert">
                                            <em class="fas fa-check-circle fa-lg text-success" [ngClass]="{'fa-chevron-up': part.expanded}"></em>
                                        </a>
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="part.makeCode">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        {{part.locationCode}} {{part.locationName}}
                                    </td>
                                    <td>
                                        <ngb-highlight [result]="part.partNumber">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <ngb-highlight [innerHTML]="part.description">
                                        </ngb-highlight>
                                    </td>
                                    <td class="text-right">
                                        <ngb-highlight [result]="part.unitPrice |number: '1.2-2'">
                                        </ngb-highlight>
                                    </td>
                                    <td class="text-right">
                                        <ngb-highlight [result]="part.unitPriceInclVat |number: '1.2-2'">
                                        </ngb-highlight>
                                    </td>
                                    <td class="text-right">
                                        <ngb-highlight [result]="part.quantity">
                                        </ngb-highlight>
                                    </td>
                                    <td class="text-right">
                                        <ngb-highlight [result]="part.availableQuantity">
                                        </ngb-highlight>
                                    </td>
                                    <td>
                                        <input class="form-control customize-textbox size" type="text" [value]="part.qty" [ngModel]="part.qty | number:'1.2-2'" maxlength="10" (keypress)="isQtyPrice($event,part.qty)" (ngModelChange)="checkAlterQty($event, i)" />
                                    </td>
                                </tr>
                                <tr class="table-active" *ngIf="part.expanded">
                                    <td colspan="12" class="p-2 pl47">
                                        <table class="tablest1 border">
                                            <thead>
                                                <tr>
                                                    <th scope="col" translate>lblMake</th>
                                                    <th scope="col" translate>lblLocationName</th>
                                                    <th scope="col" translate>lblPartNumber</th>
                                                    <th scope="col" translate>lblDescription</th>
                                                    <th scope="col" class="text-right" translate>lblPrice</th>
                                                    <th scope="col" class="text-right" translate>lblPriceInc</th>
                                                    <th scope="col" class="text-right" translate>lblTotalQty</th>
                                                    <th scope="col" class="text-right" translate>lblAvlQty</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngIf="part.partLocationList?.length>0; else load_NotFoundPartLocations_Template">
                                                    <ng-container *ngFor="let loc of part.partLocationList; let j=index">
                                                        <tr>
                                                            <td>
                                                                <ngb-highlight [result]="loc.makeCode">
                                                                </ngb-highlight>
                                                            </td>
                                                            <td>
                                                                {{loc.locationCode}} {{loc.locationName}}
                                                            </td>
                                                            <td>
                                                                <ngb-highlight [result]="loc.partNumber">
                                                                </ngb-highlight>
                                                            </td>
                                                            <td>
                                                                <ngb-highlight [innerHTML]="loc.description">
                                                                </ngb-highlight>
                                                            </td>
                                                            <td class="text-right">
                                                                <ngb-highlight [result]="loc.unitPrice |number: '1.2-2'">
                                                                </ngb-highlight>
                                                            </td>
                                                            <td class="text-right">
                                                                <ngb-highlight [result]="loc.unitPriceInclVat |number: '1.2-2'">
                                                                </ngb-highlight>
                                                            </td>
                                                            <td class="text-right">
                                                                <ngb-highlight [result]="loc.quantity">
                                                                </ngb-highlight>
                                                            </td>
                                                            <td class="text-right">
                                                                <ngb-highlight [result]="loc.availableQuantity">
                                                                </ngb-highlight>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                </ng-container>
                                                <ng-template #load_NotFoundPartLocations_Template>
                                                    <tr>
                                                        <td colspan="8" class="no-record" translate>
                                                            lblNoRecordsFound</td>
                                                    </tr>
                                                </ng-template>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                        <ng-template #load_NotFoundAlter_Template>
                            <tr>
                                <td colspan="15" class="no-record" translate>lblNoRecordsFound</td>
                            </tr>
                        </ng-template>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" aria-label="Center Align" (click)="onSaveAlternativeItems()" translate>lblAdd</button>
        <button type="button" class="btn btn-secondary" (click)="OnClose()" aria-label="Center Align" translate>lblClose</button>
    </div>
